import script from "./corpEvents.vue?vue&type=script&lang=js"
export * from "./corpEvents.vue?vue&type=script&lang=js"

import "./corpEvents.vue?vue&type=style&index=0&id=c9485090&lang=scss"

const __exports__ = script;

export default __exports__